export const reportsRacingMultipleCrewsMultipleSessions = {
    namespaced: true,

    state: {
        filterFields: {
            crews: [],
            sessions: []
        },
        filter: {
            crews: [],
            sessions: []
        },
        table: {
            selectedTypes: ['time', 'pace', 'prognostic', 'strokeRate'],
            sortOrder: null
        }
    },

    getters: {
        getFilter(state) {
            return state.filter;
        },

        getFilterFields(state) {
            return state.filterFields;
        },

        selectedTypes(state) {
            return state.table.selectedTypes;
        },

        sortOrder(state) {
            return state.table.sortOrder;
        }
    },

    mutations: {
        selectType(state, { event, type }) {
            const index = state.table.selectedTypes.indexOf(type);
            if (event) {
                index === -1 && state.table.selectedTypes.push(type);
            } else {
                index !== -1 && state.table.selectedTypes.splice(index, 1);
            }
        },

        setSortOrder(state, sortOrder) {
            state.table.sortOrder = sortOrder;
        },

        toggleItem(state, payload) {
            const indexOf = state.filter[payload.type].indexOf(payload.item.id);

            if (payload.event && indexOf === -1) {
                Vue.set(state.filter[payload.type], state.filter[payload.type].length, payload.item.id);
            } else if (!payload.event && indexOf !== -1) {
                state.filter[payload.type].splice(indexOf, 1);
            }
        },

        setFilterFieldsCrews(state, payload) {
            state.filterFields.crews = payload;
        },

        setFilterFieldsSessions(state, payload) {
            state.filterFields.sessions = payload;
        },

        resetState(state) {
            state.filterFields = {
                crews: [],
                sessions: []
            };
            state.filter = {
                crews: [],
                sessions: []
            };
            state.table = {
                selectedTypes: ['time', 'pace', 'prognostic', 'strokeRate'],
                sortOrder: null
            };
        }
    },

    actions: {
        setFilterCrews({ commit }, payload) {
            commit('setFilterFieldsCrews', payload);
            payload.forEach(crew => commit('toggleItem', { event: true, item: crew, type: 'crews' }));
        },

        setFilterSessions({ commit }, payload) {
            commit('setFilterFieldsSessions', payload);
            payload.forEach(session => commit('toggleItem', { event: true, item: session, type: 'sessions' }));
        }
    }
};

export default reportsRacingMultipleCrewsMultipleSessions;
